import { fetchCookieUser } from 'App/api/cookieUser';
import { fetchLoggedInUserDetails } from 'App/api/loginApi';
import { useQuery } from '@tanstack/react-query';
import { FOUNDATION } from 'config/features';
import { useToken } from 'store/hooks/useToken';
import { userQueryKey } from './queryKeys';

export const userQueryOptions = ({ token } = {}) => ({
  queryKey: userQueryKey(),
  queryFn: () => (FOUNDATION ? fetchCookieUser() : fetchLoggedInUserDetails({ token })),
  retry: false,
  staleTime: Number.POSITIVE_INFINITY,
});

export const useUserQuery = () => {
  const token = useToken();

  return useQuery({
    ...userQueryOptions({ token }),
    enabled: FOUNDATION || !!token,
  });
};
